import axios from "./axiosInstance";

const webAPI = {
  register: (payload) => axios.post("register", payload),
  dashboard: () => axios.get("dashboard"),

  getList: (params) => axios.get("admin/participants/list", { params }),
};

export default webAPI;
